<template>
	<v-navigation-drawer v-model="mobileNav" app width="250" temporary color="primary" dark>
		<v-list nav dense>
			<v-list-item :to="homeRoute" exact>
				<v-list-item-title>Home</v-list-item-title>
			</v-list-item>
			<v-list-item :to="eventUrl + 'registration'">
				<v-list-item-title>Registration</v-list-item-title>
			</v-list-item>
			<v-list-item :to="eventUrl + 'program'">
				<v-list-item-title>Program</v-list-item-title>
			</v-list-item>
			<v-list-item :to="eventUrl + 'social-gathering'">
				<v-list-item-title>Social Gathering</v-list-item-title>
			</v-list-item>
			<v-list-item :to="eventUrl + 'travel'">
				<v-list-item-title>Travel</v-list-item-title>
			</v-list-item>
			<v-list-item :to="eventUrl + 'faq'">
				<v-list-item-title>FAQ & Contact</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'mobile-navigation-aspac',
	computed: {
		...mapState(['language']),
		mobileNav: {
			get() {
				return this.$store.state.mobileNav
			},
			set(val) {
				this.$store.state.mobileNav = val
			},
		},
		homeRoute() {
			return this.language === 'en' ? `${this.eventUrl}` : `${this.eventUrl}${this.language}`
		},
	},
	data: () => ({
		eventUrl: '/events/aspac-meeting/',
	}),
}
</script>
